import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  faxId: yup.number().required(),
  patientId: yup.number().required(),
});

export const useEfaxAssignPatientMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) =>
      http.post(
        HTTP_ENDPOINTS.efax.assignPatient(),
        requestSchema.validateSync(dto, {
          strict: true,
        }),
      ),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.efax.faxes],
        });

        options?.onSuccess?.(...args);
      },
    },
  );
};
